
import { defineComponent, computed } from "vue";
import OrderHeaderChangeActions from "@/components/OrderHeaderChangeActions.vue";
import BackAndCancelFooter from "@/components/BackAndCancelFooter.vue";
import ViewHeader from "@/components/ViewHeader.vue";
import { useStore } from "@/store";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import swal from "sweetalert2";

export default defineComponent({
  props: {
    productId: {
      type: Number,
      required: true,
    },
  },
  components: {
    OrderHeaderChangeActions,
    BackAndCancelFooter,
    ViewHeader,
  },
  async setup(props) {
    const store = useStore();
    const router = useRouter();
    const clientExist = computed(() => store.getters.orderBusinessClientExist);
    const { t } = useI18n();
    async function removeBusinessClient() {
      var somePoductWithCoupon = store.state.order.products.some(
        (x) => x.priceLine.couponId
      );
      if (somePoductWithCoupon) {
        const result = await swal.fire({
          text: t("cashier.alert.differen-current-order"),
          icon: "warning",
          iconColor: "",
          showCancelButton: true,
          cancelButtonText: t("cashier.label.no"),
          confirmButtonText: t("cashier.label.yes"),
          customClass: {
            confirmButton: "popup-bookit-button",
            cancelButton: "close-button-wrapper popup-bookit-button",
          },
          buttonsStyling: false,
        });
        if (!result.isConfirmed) {
          router.push({
            name: "productPriceLines",
            params: { productId: props.productId },
          });
          return;
        }
      }
      store.dispatch("clearCouponsFromBasket");
      router.push({
        name: "productPriceLines",
        params: { productId: props.productId },
      });
    }
    function ShowBusinessClients() {
      router.push({ name: "businessClients" });
    }
    return { clientExist, ShowBusinessClients, removeBusinessClient };
  },
});
